/** Client-side read of the unlock cookie set by LeadCaptureForm on reveal/redirect. */
export function hasLeadMagnetUnlockCookie(slug: string): boolean {
  const prefix = `${slug}_unlocked=`
  return document.cookie.split(';').some((part) => part.trim().startsWith(prefix))
}
